import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import { List, Map } from 'immutable'
import { addDays } from 'date-fns'
import { formatPrice, getFreeTrialPeriod } from '../../../services/plans/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import { formatDateWithTimezonOffset, getCurrentTime, getFormattedLocaleDate } from '../../../services/date-time/index'
import { getPrimary } from '../../../services/languages/index'
import { GIFT_SUBSCRIPTION_STATE } from '../../../services/gift/index'
import { EUR, CAD } from '../../../services/currency/index'
import { FR } from '../../../services/languages/constants'
import Button, { TYPES } from '../../Button/index'
import { getAuthIsLoggedIn } from '../../../services/auth/index'

function CartSinglePageOrderSummary (props) {
  const {
    auth,
    plans,
    user,
    staticText,
    userAccount,
    show,
    onEditMail,
    onChangePlan,
  } = props

  const selectedPlan = plans.get('selection', Map())
  const isLoggedIn = getAuthIsLoggedIn(auth)

  // return null if no plan selected or user is not logged in
  if (selectedPlan.size === 0 || !isLoggedIn) {
    return null
  }

  const planFreeTrialPeriod = getFreeTrialPeriod(plans.getIn(['selection', 'segments'], List()))
  const formattedDate = new Date(addDays(getCurrentTime(), planFreeTrialPeriod))
  const userLanguage = getPrimary(user.getIn(['data', 'language']))
  const giftSubscriptionActive = userAccount.getIn(['details', 'data', 'gift', 'status']) === GIFT_SUBSCRIPTION_STATE.ACTIVE
  const giftPaidThroughDate = userAccount.getIn(['details', 'data', 'gift', 'paidThroughDate'])
  const expireDate = getFormattedLocaleDate(
    giftSubscriptionActive ? giftPaidThroughDate : formatDateWithTimezonOffset(formattedDate),
    userLanguage,
  )
  const initialPrice = selectedPlan.get('costs').first()
  const planPrice = selectedPlan.get('costs').last()
  const currencyIso = selectedPlan.get('currencyIso')
  let showCurrencyIso = true

  if (currencyIso === EUR || (currencyIso === CAD && userLanguage === FR)) {
    showCurrencyIso = false
  }

  const formattedPlanPrice = formatPrice(currencyIso, planPrice, showCurrencyIso, '*', userLanguage)
  const showFormattedPlanPrice = planFreeTrialPeriod || giftSubscriptionActive
  const totalDueNow = showFormattedPlanPrice
    ? formatPrice(currencyIso, '0', showCurrencyIso, null, userLanguage)
    : formatPrice(currencyIso, initialPrice, showCurrencyIso, showFormattedPlanPrice ? '' : '*', userLanguage)
  const totalDueOn = `${staticText.getIn(['data', 'totalDueOn'])} ${expireDate}`

  return (
    <div className={`cart-single-page__order-summary${show ? ' cart-single-page__order-summary--show' : ''}`}>
      <div className="cart-single-page__order-summary-content">
        <div className="cart-single-page__order-summary-email">
          <div className="cart-single-page__order-summary-email-label">
            <span className="cart-single-page__order-summary-label-number">1. </span>
            {user.getIn(['data', 'mail']) || user.getIn(['updateUser', 'email'])}
          </div>
          <Button
            type={TYPES.LINK}
            onClick={onEditMail}
            className="cart-single-page__order-summary-button"
          >
            {staticText.getIn(['data', 'edit'])}
            <span className="cart-single-page__order-summary-button-icon" />
          </Button>
        </div>
        <div className="cart-single-page__order-summary-plan">
          <div className="cart-single-page__order-summary-plan-label">
            <span className="cart-single-page__order-summary-label-number">2. </span>
            {staticText.getIn(['data', 'plan'])}
            <span className="cart-single-page__order-summary-bold-text">{selectedPlan.get('heading')}</span>
          </div>
          <Button
            type={TYPES.LINK}
            onClick={onChangePlan}
            className="cart-single-page__order-summary-button"
          >
            {staticText.getIn(['data', 'change'])}
            <span className="cart-single-page__order-summary-button-icon" />
          </Button>
        </div>
        <div className="cart-single-page__order-summary-total">
          <div className="cart-single-page__order-summary-total-label">{totalDueOn}</div>
          <div className="cart-single-page__order-summary-total-value">{formattedPlanPrice}</div>
        </div>
        <div className="cart-single-page__order-summary-total cart-single-page__order-summary-total--large">
          <div className="cart-single-page__order-summary-total-label">{staticText.getIn(['data', 'totalDueNow'])}</div>
          <div className="cart-single-page__order-summary-total-value cart-single-page__order-summary-bold-text">{totalDueNow}</div>
        </div>
      </div>
    </div>
  )
}

CartSinglePageOrderSummary.defaultProps = {
  show: false,
  onEditMail: () => {},
  onChangePlan: () => {},
}

export default compose(
  connectStaticText({ storeKey: 'CartSinglePage' }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      plans: state.plans,
      user: state.user,
      userAccount: state.userAccount,
    }),
  ),
)(CartSinglePageOrderSummary)
